import type {TariffsCountry} from '@yandex-delivery/api/model/tariffs'
import {useMemo} from 'react'
import {useHistory} from 'react-router-dom'

import {useConfig} from '../../../../config'
import {useModalControls, useModalState} from '../../../../hooks'
import {ModalId} from '../../../../types'

/** @deprecated https://st.yandex-team.ru/CARGODEV-47716 */
export const useCountriesModal = (countries?: TariffsCountry[]) => {
  const {push, createHref} = useHistory()
  const {getPath} = useConfig()
  const {closeModal, openModal} = useModalControls(ModalId.COUNTRY_MODAL)
  const {isOpened} = useModalState(ModalId.COUNTRY_MODAL)

  // Функция для преобразования страны в NavList item
  const navListCountries = useMemo(() => {
    if (!countries) return []
    return countries.map((country: TariffsCountry) => {
      const path = getPath({country: country.id})
      const hrefWithBasename = createHref({pathname: path})

      return {
        label: country.title,
        link: {
          href: hrefWithBasename,
          current: false,
          onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
            // Поддержка открытия ссылки в новой вкладке
            if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) return

            e.preventDefault()
            push(path)
            closeModal()
          },
        },
      }
    })
  }, [createHref, getPath, push, closeModal, countries])

  return {
    isOpened,
    openModal,
    closeModal,
    navListCountries,
  }
}
